import { put, takeEvery, call } from '@redux-saga/core/effects';
import {
  get_partners,
  get_partners_success,
  get_partners_error,
  get_partners_row,
  get_partners_row_success,
  get_partners_row_error,
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';

function* getPartnerSaga({ payload: { page = 1, limit = 1000, searchString } }) {
  try {
    const search = searchString ? `&search=${searchString}` : ``;
    const { data } = yield call(
      api.get,
      `/partners?page=${page}&limit=${limit}${search}`,
    );
    yield put({
      type: get_partners_success.type,
      payload: data.data,
    });
  } catch (error) {
    yield put({
      type: get_partners_error.type,
    });
    toast.error(
      !error?.response?.data?.status_code === 400
        ? error.toString()
        : error?.response?.data?.message,
    );
  }
}

function* getPartnerRowSaga({ payload: { page = 1, limit = 1000, searchString } }) {
  try {
    const search = searchString ? `&search=${searchString}` : ``;
    const { data } = yield call(
      api.get,
      `/partners?page=${page}&limit=${limit}${search}`,
    );
    yield put({
      type: get_partners_row_success.type,
      payload: data.data,
    });
  } catch (error) {
    yield put({
      type: get_partners_row_error.type,
    });
    toast.error(
      !error?.response?.data?.status_code === 400
        ? error.toString()
        : error?.response?.data?.message,
    );
  }
}

function* partnerSagas() {
  yield takeEvery(get_partners.type, getPartnerSaga);
  yield takeEvery(get_partners_row.type, getPartnerRowSaga);
}

export default partnerSagas;
